import * as THREE from 'three'

// Module-level cache: one MeshStandardMaterial per solid color hex,
// shared across all meshes. Replaces the old pattern of allocating a
// fresh MeshStandardMaterial inside applyColorToObject on every recolor
// for every mesh (#4 in §14.1 of ARCHITECTURE.md).
//
// Cached materials carry `userData.cached = true` so disposal sites
// (disposeObject, applyColorToObject's old-material cleanup) can skip
// them — disposing a cached material would corrupt every other mesh
// that still references it.
const solidColorCache = new Map<string, THREE.MeshStandardMaterial>()

let chromeRodMaterial: THREE.MeshStandardMaterial | null = null

const normaliseHex = (hex: string): string => hex.trim().toLowerCase()

export const getChromeRodMaterial = (): THREE.MeshStandardMaterial => {
  if (!chromeRodMaterial) {
    chromeRodMaterial = new THREE.MeshStandardMaterial({
      color: '#c0c0c0',
      metalness: 0.9,
      roughness: 0.1,
      envMapIntensity: 1.0,
    })
    chromeRodMaterial.userData.cached = true
  }
  return chromeRodMaterial
}

export const getSolidColorMaterial = (
  colorHex: string
): THREE.MeshStandardMaterial => {
  const key = normaliseHex(colorHex)
  let material = solidColorCache.get(key)
  if (!material) {
    material = new THREE.MeshStandardMaterial({
      color: colorHex,
      roughness: 0.8,
      metalness: 0.0,
    })
    material.userData.cached = true
    solidColorCache.set(key, material)
  }
  return material
}

export const isCachedMaterial = (material: THREE.Material): boolean => {
  return material.userData?.cached === true
}
